// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3sbXY","footer":"ModalUpdate_footer__3zurM"};